import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  unReadNotificationCount: 0,
  voiceOptions: [],
};

const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  //   reducer needs a map
  reducers: {
    setUnReadNotificationCount(state, action) {
      state.unReadNotificationCount = action.payload;
    },
    setVoiceOptions(state, action) {
      state.voiceOptions = action.payload;
    },
  },
});

export const { setUnReadNotificationCount, setVoiceOptions } =
  commonSlice.actions;

export default commonSlice.reducer;
